'use client';

import { Suspense, type ReactNode } from 'react';
import HomeBuildingGuideList from '../components/HomeBuildingGuideList';
import { HomeBuildingGuideItem } from '../data/guides';
import type { TransformedGuidesLandingData } from '@/types/guides-landing';

interface HomeBuildingGuideClientProps {
  locale: string;
  guides: HomeBuildingGuideItem[];
  landingData?: TransformedGuidesLandingData | null;
  /**
   * Streaming slot for the FAQ + enquiry block at the page bottom. The
   * lead-forms Strapi fetch happens in an async Server Component over
   * in `page.tsx` and is wrapped in `<Suspense>`, so above-fold content
   * paints without waiting on it.
   */
  faqSlot?: ReactNode;
}

function HomeBuildingGuideSkeleton() {
  return <div className="min-h-screen bg-[#f8f7f4]" />;
}

export default function HomeBuildingGuideClient({
  locale,
  guides,
  landingData,
  faqSlot,
}: HomeBuildingGuideClientProps) {
  return (
    <Suspense fallback={<HomeBuildingGuideSkeleton />}>
      <HomeBuildingGuideList
        locale={locale}
        guides={guides}
        landingData={landingData}
        faqSlot={faqSlot}
      />
    </Suspense>
  );
}
